import React from "react";
import { Link } from "react-router-dom";
import LegalPage from "@/components/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Termini e Condizioni" description="Termini di servizio HostMarket" testid="terms-page">
      <p>Utilizzando HostMarket (il "Servizio") accetti i presenti Termini e Condizioni. Ti invitiamo a leggerli con attenzione. Gestore: <strong>Vita da Host</strong>, P.IVA 02903680995, Genova.</p>

      <h2>1. Oggetto del servizio</h2>
      <p>HostMarket è una <strong>directory/vetrina digitale</strong> che permette a professionisti (fotografi, home stager, property manager, commercialisti, avvocati ecc.) di pubblicare annunci rivolti a host, property manager e B&B del settore affitti brevi. HostMarket <strong>non è un marketplace</strong>: non interviene nelle trattative tra professionisti e clienti né gestisce le transazioni commerciali derivanti.</p>

      <h2>2. Registrazione</h2>
      <ul>
        <li>Per pubblicare un annuncio occorre registrare un account con email valida e password di almeno 8 caratteri.</li>
        <li>Devi avere almeno 18 anni.</li>
        <li>Sei responsabile della riservatezza delle tue credenziali.</li>
      </ul>

      <h2>3. Piani e pagamenti</h2>
      <p>La pubblicazione degli annunci richiede un abbonamento attivo:</p>
      <ul>
        <li><strong>Basic</strong>: 6,99€/mese o 70€/anno</li>
        <li><strong>Standard</strong>: 14,99€/mese o 150€/anno</li>
        <li><strong>Premium</strong>: 19,90€/mese o 190€/anno</li>
        <li><strong>Home Spotlight</strong>: 9,90€ per 30 giorni (opzionale, slot limitati a 8)</li>
      </ul>
      <p>Gli abbonamenti sono <strong>ricorrenti</strong> e si rinnovano automaticamente fino a disdetta. Puoi annullare il rinnovo in qualsiasi momento dalla dashboard; l'abbonamento resta valido fino alla fine del periodo già pagato. Pagamenti gestiti da Stripe Payments Europe.</p>

      <h2>4. Contenuti degli annunci</h2>
      <p>Pubblicando un annuncio garantisci che:</p>
      <ul>
        <li>I contenuti (testo, foto, video, contatti) sono di tua proprietà o hai il diritto di pubblicarli.</li>
        <li>Non sono ingannevoli, diffamatori, illegali o in violazione di diritti di terzi.</li>
        <li>Concedi a HostMarket una licenza non esclusiva per pubblicarli sulla piattaforma.</li>
      </ul>

      <h2>5. Comportamenti non ammessi</h2>
      <ul>
        <li>Spam, phishing, manipolazione click/visualizzazioni.</li>
        <li>Pubblicazione di contenuti illeciti (pornografia, violenza, hate speech).</li>
        <li>Utilizzo di bot, scraping massivo, reverse engineering.</li>
        <li>Vendita/cessione dell'account.</li>
      </ul>
      <p>La violazione può comportare la <strong>sospensione immediata dell'account</strong> senza rimborso.</p>

      <h2>6. Diritto di recesso (consumatori)</h2>
      <p>Se sei un <strong>consumatore</strong> ai sensi del Codice del Consumo (D.Lgs. 206/2005) hai 14 giorni di tempo dal primo pagamento per recedere, contattando <a href="mailto:team@vitadahost.it">team@vitadahost.it</a>. Diversamente il servizio è considerato "professionale" e il recesso non si applica ai successivi rinnovi.</p>

      <h2>7. Limitazione di responsabilità</h2>
      <p>HostMarket non è parte dei rapporti commerciali tra professionisti e clienti. Non garantiamo la qualità, l'affidabilità o la legalità dei servizi offerti dai professionisti. Fai le tue verifiche (partita IVA, recensioni, referenze) prima di contrattualizzare.</p>

      <h2>8. Proprietà intellettuale</h2>
      <p>Il marchio HostMarket, il logo, il design e il codice sono di proprietà di Vita da Host. Tutti i diritti riservati.</p>

      <h2>9. Modifiche ai termini</h2>
      <p>Ci riserviamo il diritto di aggiornare questi Termini. Notifichiamo le modifiche rilevanti via email con almeno 30 giorni di anticipo. Continuando a usare il Servizio dopo l'aggiornamento accetti i nuovi termini.</p>

      <h2>10. Legge applicabile e foro competente</h2>
      <p>I presenti Termini sono regolati dalla <strong>legge italiana</strong>. Per le controversie il foro competente è <strong>Genova</strong>, salvo il foro del consumatore se applicabile.</p>

      <h2>11. Contatti</h2>
      <p>Per qualunque richiesta scrivici a <a href="mailto:team@vitadahost.it">team@vitadahost.it</a>. Vedi anche <Link to="/privacy">Privacy Policy</Link> e <Link to="/cookie">Cookie Policy</Link>.</p>
    </LegalPage>
  );
}
